export function isLeftButtonPressed(e: React.MouseEvent | MouseEvent) {
  return e.buttons === 1;
}

export function isRightButtonPressed(e: React.MouseEvent | MouseEvent) {
  return e.buttons === 2;
}
